import React from "react";
import { useSelector } from "react-redux";
import { ChartData } from "chart.js";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { verticalChartOptions } from "../../../../../utils/charts/chartOptions";
import ChartLegend from "../../ChartLegend/ChartLegend";

import theme from "../../../../../components/styles/theme/theme";
import { RootState } from "../../../../../store/store";

const EconomicValueChainStageChart: React.FC = () => {
  const { t } = useTranslation();

  const {
    statistics: { statisticsForSelectedCountry },
  } = useSelector((state: RootState) => state);

  const statisticsDataArray = [
    [
      null,
      null,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_valueChainLink
          .downstream_suppliers_and_outlets,
    ],
    [
      null,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_valueChainLink
          .theSystem_theCocaColaSystem,
      null,
    ],
    [
      null,
      null,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_valueChainLink.downstream_Vat,
    ],
    [
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_valueChainLink
          .upstream_suppliers_and_outlets,
      null,
      null,
    ],
    [
      null,
      null,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_valueChainLink
          .downstream_suppliers_and_outlets_suppliers,
    ],
    [
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_valueChainLink
          .upstream_suppliers_and_outlets_suppliers,
      null,
      null,
    ],
  ].map((row) => row.map((value) => (value === 0 ? null : value)));

  const labels = [
    t("charts.upstream_label"),
    t("charts.system_label"),
    t("charts.downstream_label"),
  ];
// @ts-ignore
  const data: ChartData<"bar"> = {
    labels,
    datasets: [
      {
        label: t("charts.outlets_label") || "",
        data: statisticsDataArray[0],
        backgroundColor: theme.palette.primary["700"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.system_label") || "",
        data: statisticsDataArray[1],
        backgroundColor: theme.palette.secondary["600"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.vat_label") || "",
        data: statisticsDataArray[2],
        backgroundColor: theme.palette.primary["500"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.first_tier_suppliers_label") || "",
        data: statisticsDataArray[3],
        backgroundColor: theme.palette.secondary["200"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },

      {
        label: t("charts.outlets_suppliers_label") || "",
        data: statisticsDataArray[4],
        backgroundColor: theme.palette.primary["300"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },

      {
        label: t("charts.suppliers_suppliers_label") || "",
        data: statisticsDataArray[5],
        backgroundColor: theme.palette.secondary["50"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
    ],
  };

  return (
    <>
      <Bar options={verticalChartOptions("economic_value_added")} data={data} />
      <ChartLegend data={data} />
    </>
  );
};

export default EconomicValueChainStageChart;
